module.exports = __webpack_public_path__ + "static/media/HKGrotesk-Light.b100aa18.ttf";